namespace Matrix.Data {
    export interface SecurityMatchRulesetRuleRow {
        RulesetCode?: string;
        RuleCode?: string;
        Priority?: number;
        Enabled?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AutoReview?: boolean;
        RulesetCodeDescription?: string;
        RulesetCodeRowId?: number;
        RuleCodeDescription?: string;
        RuleCodeCommandText?: string;
        RuleCodeRowId?: number;
    }

    export namespace SecurityMatchRulesetRuleRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'RuleCode';
        export const localTextPrefix = 'Data.SecurityMatchRulesetRule';
        export const lookupKey = 'Data.SecurityMatchRulesetRule';

        export function getLookup(): Q.Lookup<SecurityMatchRulesetRuleRow> {
            return Q.getLookup<SecurityMatchRulesetRuleRow>('Data.SecurityMatchRulesetRule');
        }
        export const deletePermission = 'DataAdmin:SecurityMatchRulesetRule';
        export const insertPermission = 'DataAdmin:SecurityMatchRulesetRule';
        export const readPermission = 'Read:SecurityMatchRulesetRule';
        export const updatePermission = 'DataAdmin:SecurityMatchRulesetRule';

        export declare const enum Fields {
            RulesetCode = "RulesetCode",
            RuleCode = "RuleCode",
            Priority = "Priority",
            Enabled = "Enabled",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AutoReview = "AutoReview",
            RulesetCodeDescription = "RulesetCodeDescription",
            RulesetCodeRowId = "RulesetCodeRowId",
            RuleCodeDescription = "RuleCodeDescription",
            RuleCodeCommandText = "RuleCodeCommandText",
            RuleCodeRowId = "RuleCodeRowId"
        }
    }
}
